<template>
<!-- 首页顶部三点导航 -->
<div id="see-nav">
  <!-- title -->
    <div class="top-title">
      <img src="../../assets/img/login-img/3-1档案-返回ic@2x.png" alt="" class="back-icon" @click="goDetail">
      <p class="title-text siyuan-bold">导航</p>
    </div>
    <!-- end -->
    <ul class="nav-box">
      <li @click="goDetail(item)" class="nav-item" v-for="(item,index) in navData" :key="index">
        <img :src="item.icon_url" alt="" class="nav-img">
        <span class="img-text" v-if="index == 0">首页</span>
        <span class="img-text" v-if="index !== 0">{{item.title}}</span>
      </li>

    </ul>
</div>
</template>

<script>
// import eventBus from '../../common/eventBus.js'
import { navList2 } from '@/api/index'
export default {
  data () {
    return {
      navData: []
    }
  },
  beforeMount () {
    this.fetch()
  },
  methods: {
    // goBack () {
    //   this.$router.back(-1)
    // },
    fetch () {
      this.$http.get(navList2).then(res => {
        if (res.data.error === 0) {
          this.navData = res.data.data
        }
      })
    },
    goDetail (val) {
      // 旧版专题跳转
      // eventBus.$emit('indexDepart', val.department_id || '')
      // eventBus.$emit('navTitle', val.title || '')
      // localStorage.setItem('indexDepart', val.department_id || '')
      // 新版专题跳转
      if (val.department_id == null || val.department_id == '') {
        this.$router.push('/SdSeeDoctor')
      } else {
        this.$router.push({
          path: '/SdSeeGroup',
          query: {
            departmentId: val.department_id || ''
          }
        })
      }
    }
  }
}
</script>

<style lang="postcss">
#see-nav {
  & .top-title {
    padding: 27px 0;
    position: fixed;
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: #fffffd;
    box-shadow: 1px 8px 100px rgba(0, 0, 0, 0.1);
    z-index: 999;
    & .back-icon {
      width: 16px;
      height: 32px;
      position: absolute;
      left: 30px;
    }
    & .title-text {
      font-size: 34px;
      font-family: "SourceHanSansCN Medium";
      font-weight: 400;
    }
  }
  & .nav-box {
    height: 100%;
    padding-top: 150px;
    display: flex;
    background-color: #fffffd;
    /* justify-content: space-between; */
    flex-wrap: wrap;
    & .nav-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 50px;
      margin-bottom: 60px;
      width: 148px;
      min-width: 80px;
      max-width: 150px;
      & .nav-img {
        width: 80px;
        height: 80px;
        margin-bottom: 20px;
      }
      & .img-text {
        width: 150px;
        font-size: 30px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shenduSeeDoctor/SdSeeNav.vue